'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';

export function useAuthCheck() {
  const router = useRouter();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const userData = localStorage.getItem('user');

        if (!token || !userData) {
          setIsChecking(false);
          return;
        }

        // Check if user is suspended or deleted
        const response = await fetch('/api/auth/check-status', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          // User is suspended/deleted or token invalid
          localStorage.removeItem('authToken');
          localStorage.removeItem('user');
          
          const url = new URL(window.location.href);
          const message = response.status === 403 ? 'suspended' : 'deleted';
          router.push(`/login?message=${message}`);
          return;
        }

        const data = await response.json();
        
        // Update user data in localStorage
        localStorage.setItem('user', JSON.stringify(data.user));

      } catch (error) {
        console.error('Auth check failed:', error);
        // On error, clear auth and redirect to login
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        router.push('/login');
      } finally {
        setIsChecking(false);
      }
    };

    checkAuthStatus();

    // Set up periodic check (every 30 seconds)
    const interval = setInterval(checkAuthStatus, 30000);

    return () => clearInterval(interval);
  }, [router]);

  return { isChecking };
}
